<template>
  <div class="f-h config-actions">
    <!-- eslint-disable-next-line vue/no-v-html -->
    <div class="field-hint" v-html="$t('message.CONFIG_ACTIONS_HINT')" />
    <div class="v-centerer mt10em">
      <div class="legend mr5em">
        {{ `${$t('message.CONFIG_ACTION_PLAN_TEMPLATES')}${$t('message.TWO_DOTS')}` }}
      </div>
      <div class="basic-search-field v-centerer">
        <Icon>{{ searchMedium }}</Icon>
        <input v-model="search" :placeholder="$t('message.SEARCH_PH')">
      </div>
    </div>

    <SettingsActionPlanList config :filter-function="filterItemsFunction" />
  </div>
</template>

<script>
/**
 * This page allows users to edit th action plans of the company.
 * Action plans can then be assigned to team for proper standardization.
 */

// Components
import Icon from '@/components/icon.vue';
import SettingsActionPlanList from '@/components/settings-action-plan-list.vue';
// Mixins
import mixinConfigPages from '@/mixins/config-pages.vue';
// Utils
import { searchMedium } from '@/assets/icons';
import { FETCH_TEAMS, FETCH_ACTION_PLANS } from '@/store/action-types';

export default {

  name: 'ConfigActions',

  components: {
    Icon,
    SettingsActionPlanList,
  },

  mixins: [mixinConfigPages],

  data() {
    return {
      searchMedium,
      search: '',
      // Properties used by other components. See src/views/readme.md
      pageTitle: this.$t('message.ACTIONS'),
    };
  },

  methods: {
    refresh() {
      this.$store.dispatch(FETCH_ACTION_PLANS, { config: 1 });
      this.$store.dispatch(FETCH_TEAMS, { config: 1 });
    },
    filterItemsFunction(item) {
      const effectiveSearch = this.search.toUpperCase().split(/[\s,-./']/);
      return !effectiveSearch.some(term => !item.name.toUpperCase().includes(term));
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vars.scss";

.config-actions {
  padding: $page-content-padding;
  overflow: auto;
  box-sizing: border-box;
}
</style>
